export default "__VITE_ASSET__CJXt1_Du__"